/* eslint-disable camelcase */
import React from 'react';
import TreeView from '../../GroupTreeView/GroupTreeView';
import { ITabParams } from '../../../config/types';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../../redux/store';
import { openWorkflowStatesTab } from './WorkflowStatesUtils';
import { triggerEvent } from '../../../redux/event';
// import { updateLookupGroups } from '../../../redux/lookup';
import {
  // LookupCollection,
  WorkflowState,
  WorkflowStateCollection
} from '@digitalworkflow/dwtranslateclient';
import { setSelectedNode } from '../../../redux/activeNode';
import {
  fetchWorkflowStateGroups,
  fetchWorkflowStates
} from '../../../redux/workflowState';
import {
  builderPageTypes as BPT,
  builderPageTypes
} from '../../../config/constants/builderPageTypes';
import { updateDataEverywhere } from '../../../utils';
import { ITreeViewData } from '@digitalworkflow/dwtranslateclient/lib/Models/Module/ModuleCollection';
import styles from '../Renderers.module.scss';

export const GroupsWorkflowStates = ({
  ref,
  type,
  selectedRows,
  gridReferences,
  setCurrentEventAPI,
  setSelectedRowIndex,
  setSelectedRows,
  fetchData,
  setRowSelectedFlag,
  setTabsRef,
  updateData
}: ITabParams) => {
  const groups: ITreeViewData[] = useSelector(
    (state: RootState) => state.workflowState.groups
  );
  const workflowStates: any = useSelector(
    (state: RootState) => state.workflowState.workflowStates
  );

  const dispatch = useAppDispatch();

  function reduxUpdater() {
    dispatch(fetchWorkflowStates());
    dispatch(fetchWorkflowStateGroups());
  }

  function openForm() {
    dispatch(triggerEvent('showModalEvent'));
  }

  /**
   * callback to handle when a group is clicked in tree view
   * @param title string name of the group clicked
   */
  function handleGroupClick(title: string) {
    const currentWorkflow: WorkflowState | null = workflowStates.filter(
      (state: WorkflowState) => state.data.name === title
    )?.[0];

    if (!currentWorkflow?.data.id?.length) {
      console.log('WFS not found, returning...');
      return;
    }

    const rows = [currentWorkflow.data];

    const tabId = title + '_tab';

    const tabAlreadyPresent = ref?.find(tabId);

    tabAlreadyPresent
      ? ref?.updateTab(tabId, null)
      : openWorkflowStatesTab({
          ref,
          title,
          rows,
          firstTab: false,
          type,
          selectedRows,
          gridReferences,
          fetchData,
          setSelectedRows,
          setSelectedRowIndex,
          setCurrentEventAPI,
          setRowSelectedFlag,
          setTabsRef,
          updateData,
          updateMetaData: (data) => {
            updateDataEverywhere(
              ref,
              data.id,
              data,
              builderPageTypes.workflowStates,
              reduxUpdater
            );
          }
        });

    dispatch(setSelectedNode(title));
  }

  async function handleDrop(newData: ITreeViewData[]) {
    for (let index = 0; index < newData.length; index++) {
      if (newData[index].parent !== groups[index].parent) {
        const parentIndex = newData.findIndex(
          (v) => v.id === newData[index].parent
        );
        await WorkflowStateCollection.updateWorkflowStateModule(
          newData[index].text as string,
          newData[parentIndex].text as string
        );
        dispatch(fetchWorkflowStateGroups());
        break;
      }
    }
  }

  return (
    <div id={styles.treeView} className='overflow-y-auto h-100'>
      <TreeView
        pageType={BPT.workflowStates}
        data={groups}
        setShowModal={() => openForm()}
        handleGroupClick={(title) => handleGroupClick(title)}
        handleDrop={(newTreeData: ITreeViewData[]) => handleDrop(newTreeData)}
        tabRef={ref}
      />
    </div>
  );
};

export const HistoryWorkflowStates = () => {
  return (
    <div>
      <span>History available in V2</span>
    </div>
  );
};
